import type React from 'react';

interface CheckMarkIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function CheckMarkIcon({ size = 24, ...props }: CheckMarkIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.4498 5.16491C19.8378 4.90862 20.3649 4.95103 20.7067 5.29235C21.0972 5.68287 21.0972 6.31686 20.7067 6.70739L9.70715 17.7069C9.31671 18.0973 8.68412 18.0972 8.29358 17.7069L3.2926 12.7074L3.16516 12.5506C2.9085 12.1624 2.95074 11.6342 3.2926 11.2923C3.63446 10.9505 4.1627 10.9082 4.5509 11.1649L4.70764 11.2923L8.99963 15.5858L19.2931 5.29235L19.4498 5.16491Z"
        fill="currentColor"
      />
    </svg>
  );
}
